/**
 * First, we will load all of this project's Javascript utilities and other dependencies.
 */
require('./_boot');

/**
 * Init les tooltips Bootstrap
 */
(function () {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
})();

/**
 * Automatiquement afficher des popups de notification si le Controller a envoyé un message flash
 */
(function () {
    toastr.options.positionClass = 'toast-bottom-right';
    for (const type in APP.notify) {
        const msg = APP.notify[type];

        if (msg !== '') {
            setTimeout(function () {
                switch (type) {
                    case 'info':
                        toastr.info(msg);
                        break;
                    case 'success':
                        toastr.success(msg);
                        break;
                    case 'warning':
                        toastr.warning(msg);
                        break;
                    case 'danger':
                        toastr.error(msg);
                        break;
                }
            }, 500);
        }
    }
})();

/**
 * Obfusquer certains liens pour le maillage interne du SEO
 */
(function () {
    const obfLinks = document.querySelectorAll('.js-obflink');

    if (obfLinks.length > 0) {
        obfLinks.forEach(function (obfLink) {
            if (obfLink.getAttribute('tabindex') === null) {
                obfLink.setAttribute('tabindex', '0'); // Pour l'accessibilité
            }

            if (obfLink.getAttribute('aria-label') === undefined) {
                obfLink.setAttribute('aria-label', 'Cette balise est un lien cliquable'); // Pour l'accessibilité
            }

            obfLink.addEventListener('click', function () {
                const link = window.atob(this.dataset.o);

                if (this.dataset.target === '_blank') {
                    window.open(link);
                } else {
                    window.location = link;
                }
            });
        });
    }
})();
